import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=db9f5d9c"
import script from "./ChatPopup.vue?vue&type=script&lang=js"
export * from "./ChatPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports